import axiosClient from "@/libs/axiosClient";

export const createEc2Edge = (options) => {
    return axiosClient.post(`/3rd/aws/create-ec2-edge`, options);
};
export const createEc2Slb = (options) => {
    return axiosClient.post(`/3rd/aws/create-ec2-slb`, options);
};



// WEBPACK FOOTER //
// ./src/api/3rd/aws.js